import { type ReactElement } from "react"

export interface INavSectionsItems {
  to: string
  activePaths: string[]
  label: string
  icon: ReactElement
  target?: string
  isMain?: boolean
  disabled?: boolean
  onClick?: () => void
  loading?: boolean
  testId?: string
}

export interface INavSections {
  id?: string
  title: string
  groups?: string[]
  items: INavSectionsItems[]
}

export enum ProductCategories {
  MAKEUP = "MAKEUP",
  HATS = "HATS",
  GLASSES = "GLASSES",
  SCARVES = "SCARVES",
  JEWELRY = "JEWELRY",
  EARRINGS = "EARRINGS",
  EYE_LENSES = "EYE_LENSES",
  BB_CC_CREAM = "BB_CC_CREAM",
  CC_CREAM = "CC_CREAM",
  BB_CREAM = "BB_CREAM",
  HAIRS = "HAIRS",
}
export const AvailableCategories = [
  { name: ProductCategories.MAKEUP, enabled: true },
  { name: ProductCategories.GLASSES, enabled: true },
  { name: ProductCategories.HATS, enabled: false },
  { name: ProductCategories.SCARVES, enabled: false },
  { name: ProductCategories.JEWELRY, enabled: false },
  { name: ProductCategories.EARRINGS, enabled: false },
  { name: ProductCategories.EYE_LENSES, enabled: false },
  { name: ProductCategories.BB_CC_CREAM, enabled: false },
  { name: ProductCategories.CC_CREAM, enabled: false },
  { name: ProductCategories.BB_CREAM, enabled: false },
  { name: ProductCategories.HAIRS, enabled: false },
]

export const getAllTranslatedProductCategories = (t: (key: string) => string) => {
  return {
    MAKEUP: t("productCategories.makeup"),
    HATS: t("productCategories.hats"),
    GLASSES: t("productCategories.glasses"),
    SCARVES: t("productCategories.scarves"),
    JEWELRY: t("productCategories.jewelry"),
    EARRINGS: t("productCategories.earrings"),
    EYE_LENSES: t("productCategories.eyeLenses"),
    BB_CC_CREAM: t("productCategories.bbCcCream"),
    CC_CREAM: t("productCategories.ccCream"),
    BB_CREAM: t("productCategories.bbCream"),
    HAIRS: t("productCategories.hairs"),
  }
}

export const getTranslatedProductCategories = (t: (key: string) => string) => ({
  MAKEUP: t("productCategories.makeup"),
  HATS: t("productCategories.hats"),
  GLASSES: t("productCategories.glasses"),
  SCARVES: t("productCategories.scarves"),
  JEWELRY: t("productCategories.jewelry"),
  EARRINGS: t("productCategories.earrings"),
  EYE_LENSES: t("productCategories.eyeLenses"),
  BB_CC_CREAM: t("productCategories.bbCcCream"),
  CC_CREAM: t("productCategories.ccCream"),
  BB_CREAM: t("productCategories.bbCream"),
  HAIRS: t("productCategories.hairs"),
})

export enum ProductCategoriesLink {
  MAKEUP = "/products",
  GLASSES = "/glasses",
  HATS = "/hats",
  SCARVES = "/scarves",
  JEWELRY = "/jewelry",
  EARRINGS = "/earrings",
  EYE_LENSES = "/eye-lenses",
  EYELASHES = "/eyelashes",
  BB_CC_CREAM = "/bb-cc-cream",
  CC_CREAM = "/cc-cream",
  BB_CREAM = "/bb-cream",
  HAIRS = "/hairs",
}
